import React,{useState,useEffect} from "react";
import authStorage from "../../utils/authStorage";
import { BarChart, Bar } from 'recharts';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from "../../config";
import Table from '../../components/table';
import axios from 'axios';
import moment from 'moment';
import {
    aggregateZoneTotals,
    buildParticipantRecord,
    buildSummaryGoalsRows,
    readStoredObject,
    summaryGoalsFileName,
    summaryGoalsSheetName,
    CATEGORY_ACHIEVED,
    CATEGORY_SHORTFALL,
} from "../../helper/summaryGoalsReport";
import downloadExcelSheet from "../../helper/downloadExcel";
const Reportcompany  =()=>{
    
    
    const navigate = useNavigate();
    const [companyList, setCompanyList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [rowHeaderData, setRowHeaderData] = useState([]);
    const [firstSelected, setFirstSelected] = useState('');
    const [selected, setSelected] = useState();
    const [userDetails, setUserDetails] = useState({});
    const [totalUserAcheivedGoal, setTotalUserAcheivedGoal] = useState([]);
    // Per-participant report rows for the current month.
    const [participants, setParticipants] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        offset: 0,
        itemsPerPage: 10,
        totalCount: 0,
    });
    const [loading, setLoading] = useState([]);

    useEffect(() => {
        let isAdmin = ['company'].includes(authStorage.getItem('roles'));

        // If roles is not admin, redirect to dashboard page
        if (!isAdmin) {
            window.location = window.location.origin + '/dashboard';
            return false;
        }
    });

    const companyLabel = (userDetails?.companyName || 'Company').replace(/[^\w-]+/g, '-');

    // Guarded so a missing price or user count renders "-" rather than "$ NaN".
    const billAmount = (perUser, count) => {
        const price = Number(perUser);
        const users = parseInt(count, 10);
        if (!Number.isFinite(price) || !Number.isFinite(users)) return null;
        return price * users;
    };
    const expectedBillAmount = billAmount(userDetails?.price, userDetails?.expectedCftUser);
    const activeBillAmount = billAmount(userDetails?.price, userDetails?.userCount);

    const downloadBillingReport = () => {
        const userRange = userDetails?.userRange || "";  //ensures it's a string even if userRange is undefined or null
        const updatedUserRange = userRange.replace("-", " to ");

        // Header row then one value row, so the headings can be bolded.
        downloadExcelSheet({
            rows: [
                [
                    "Company Name", "User Range", "Price Per User", "Expected CFT User",
                    "Expected Bill Amount", "Active CFT User", "Total Bill Amount",
                ],
                [
                    userDetails?.companyName || '-',
                    updatedUserRange,
                    userDetails?.price,
                    userDetails?.expectedCftUser,
                    expectedBillAmount,
                    userDetails?.userCount,
                    activeBillAmount,
                ],
            ],
            boldRows: [0],
            fileName: `${companyLabel}-${moment().format('MMM-YYYY')}-Billing-Report.xlsx`,
            sheetName: 'Billing',
        });
    };

    /**
     * Summary & Goals report, downloaded per category so an employer can hand out
     * the recognition list and the follow-up list separately. Both files carry the
     * same header, summary and device breakdown for the whole connected
     * population, and differ only in which participants are detailed.
     *
     * Built from explicit columns — this used to hand Papa.unparse the raw user
     * documents, which shipped every Mongo field (password hashes and Fitbit
     * tokens included) to whoever downloaded it.
     */
    const downloadUserReport = (category) => {
        const { rows, boldRows, boldLabelRows } = buildSummaryGoalsRows({
            companyName: userDetails?.companyName,
            participants,
            category,
        });
        downloadExcelSheet({
            rows,
            boldRows,
            boldLabelRows,
            fileName: summaryGoalsFileName(userDetails?.companyName, category),
            sheetName: summaryGoalsSheetName(category),
        });
    };

    const achieverCount = participants.filter((r) => r.achievedGoal).length;
    const shortfallCount = participants.filter(
        (r) => !r.achievedGoal && r.hasQualifiedActivity
    ).length;

    const getCompanyReport = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/user/compData`,{
                headers: {
                    "x-access-token": authStorage.getItem("auth-token"),
                },
            });
            if (response.data) {
                // authStorage.getItem already JSON-parses, so this must NOT be
                // parsed again — doing so threw, and the catch below swallowed it,
                // leaving the whole Billing card blank and its totals as NaN.
                const dat = { ...readStoredObject(authStorage.getItem("user")) };
                const company = readStoredObject(authStorage.getItem('company'));

                if (company?.companyName) {
                    dat.companyName = company.companyName;
                }
                // Fall back to the server's own view of the company when the
                // values cached at login are missing.
                const serverUser = response?.data?.data;
                if (dat.expectedCftUser === undefined) {
                    dat.expectedCftUser = serverUser?.expectedCftUser ?? serverUser?.company?.expectedCftUser;
                }
                if (!dat.companyName) {
                    dat.companyName = serverUser?.companyName || serverUser?.company?.companyName;
                }
                dat.userCount = response?.data?.num;
                setUserDetails(dat);
            }
        } catch (error) {
            console.log("req not send : ");
            // setMsg("req not sent ");
        }
    }

    const getCompanyUsers = () => {
        const comp = readStoredObject(authStorage.getItem('company'));

        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token"),
            },
            url: `${BASE_URL}/admin/company/user/list/${comp?._id}`, //your url
            method: "GET",
        }).then((res) => {
            setUserList(res?.data?.data);
        });
    };
    const userTableRowTitle = [
        { title: "Date", key: "date", formatData: (data) => moment(data).format('DD MMM YYYY') },
        { title: "Start Time", key: "startTime" },
        { title: "End Time", key: "endTime" },
        { title: "Booked By", key: "user", formatData: (data) => data ? data?.email : '' },
    ];

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Optional: adds smooth scrolling animation
        });
        setRowHeaderData(userTableRowTitle);
        // getCompanyList();
    }, []);

    useEffect(() => {
        console.log("functionc call 128  admin company user list :: ");
            getCompanyReport();
          
                getCompanyUsers(); 
    },[]);

    const processUser = async (data) =>
        buildParticipantRecord(data, await getUserActivityRecord(data));

    useEffect(() => {
        if (!userList || (userList?.length <= 0)) {
            return;
        }

        async function processData() {
            // The company's own login is returned by the user-list endpoint but
            // is not a programme participant, so it is dropped up front.
            const ownEmail = authStorage.getItem('email');
            const members = userList.filter((u) => !ownEmail || u?.email !== ownEmail);

            const records = (await Promise.all(members.map(processUser))).filter(Boolean);

            setParticipants(records);
            // Kept as user objects: the Achieved Goal tile reads .length off this.
            setTotalUserAcheivedGoal(records.filter((r) => r.achievedGoal).map((r) => r.user));
            setLoading(false);
        }
        processData();
    }, [userList]);

    const getUserActivityRecord = async (data) => {
        setLoading(true);
        let startDate = moment().startOf('month').format('YYYY-MM-DD');
        let endDate = moment().endOf('month').format('YYYY-MM-DD');
        const fitbitUrl = (data?.fitBitId) ? `${BASE_URL}/user/getfitbitexercisedata/${startDate}/${endDate}/${data?.fitBitId}` : '';
        const garminUrl = `${BASE_URL}/user/getgarminexercisedatabydate/${startDate}/${endDate}/${data?._id}`;

        let fitbitData = fitbitUrl ? await axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: fitbitUrl,
            method: 'GET'
        }) : '';

        let garminData = await axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: garminUrl,
            method: 'GET'
        });

        // Apple members were previously invisible here — this screen only ever
        // fetched Fitbit and Garmin, so an Apple user reported zero minutes while
        // their own Summary & Goals page showed real activity. summaryGoals.jsx
        // substitutes Apple data for Garmin rather than merging, so match that.
        if (data?.isAppleConnected) {
            const appleData = await axios({
                headers: {
                    "x-access-token": authStorage.getItem("auth-token")
                },
                url: `${BASE_URL}/apple/getapplehealthdatabydate/${startDate}/${endDate}/${data?._id}`,
                method: 'GET'
            }).catch(() => null);
            if (appleData) {
                garminData = appleData;
            }
        }

        fitbitData = fitbitData?.data?.data;
        garminData = garminData?.data?.data;

        setLoading(false);
        return aggregateZoneTotals(fitbitData, garminData);
    };

return (<>
  <div className="md:mx-10 md:h-auto px-4 sm:px-0">
  <h2 className="mob-header font-medium mb-5 mt-5">Company/Report</h2>
  <div className='p-4 md:p-6 bg-white rounded-lg mt-6'>
                    <div className="text-md md:text-lg text-black">
                        Welcome, {authStorage.getItem('user-name')} !
                        <br />
                        <span className='text-gray-400 mt-2 block'>Thank you for being a part of the CFT program and training. Here is your overall journey with us!</span>
                    </div>
                </div>
                <div className="flex flex-wrap justify-center md:py-10 py-5">
                    <div className="flex flex-grow flex-col p-6 md:mr-10 mr-0 my-2 text-center text-gray-300 bg-white rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
                        <div className="flex justify-between border-b border-blue-200 border-opacity-20 mb-8">
                            <div className="text-xl tracking-tight font-medium text-black dark:text-white">
                                Billing
                            </div>
                        </div>
                        <div className="border-b border-blue-200 border-opacity-20 pb-4">
                            <div className="mb-8">
                                <div class="flex justify-between mb-1">
                                    <span class="text-md md:text-md text-[#0694F3] dark:text-white">User Range </span>
                                    <div>
                                        <span class="text-md md:text-md text-[#0694F3]">{userDetails?.userRange}</span>
                                    </div>
                                </div>
                                <div class="w-full bg-[#0694F3] rounded-full h-2 dark:bg-gray-700">
                                </div>
                            </div>
                            <div className="mb-8">
                                <div class="flex justify-between mb-1 text-[#F50F51]">
                                    <span class="text-md md:text-md">Price Per User</span>
                                    <div>
                                        <span class="text-md md:text-md text-[#F50F51]">$ {userDetails?.price}</span>
                                    </div>
                                </div>
                                <div class="w-full bg-[#F50F51] rounded-full h-2 dark:bg-gray-700">
                                </div>
                            </div>
                            <div className="">
                                <div class="flex justify-between mb-1">
                                    <div>
                                        <span class="text-md text-[#00C98E] md:text-md dark:text-white">Active CFT User</span>
                                        <span class="text-md text-white-200 md:text-md dark:text-white text-gray-400"> / Expected CFT User</span>
                                    </div>
                                    <div>
                                        <span class="text-md md:text-md text-green-400 dark:text-white">{userDetails?.userCount}</span>
                                        <span className="text-md md:text-md text-gray-400"> / {userDetails?.expectedCftUser}</span>
                                    </div>
                                </div>
                                <div class="w-full bg-[#00C98E] rounded-full h-2 dark:bg-gray-400">
                                    <div class="bg-green-400 h-2 rounded-full" style={{ width: `${((userDetails?.userCount / userDetails?.expectedCftUser) * 100)}%` }}></div>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-between pt-4">
                            <div className="text-lg font-medium text-black dark:text-white text-left">
                                <div className="text-lg font-medium text-black dark:text-white">
                                    Total Cost (Expected CFT User) : $ {expectedBillAmount ?? '-'}
                                </div>
                                <div className="text-lg font-medium text-black dark:text-white">
                                    Total Cost (Active CFT User) : $ {activeBillAmount ?? '-'}
                                </div>
                            </div>
                            <div onClick={() => downloadBillingReport()} className="flex text-[#0694F3] font-medium cursor-pointer">
                                Download Report
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0694F3" class="w-5 h-5 ml-2">
                                    <path fill-rule="evenodd" d="M12 2.25a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3a.75.75 0 01.75-.75zm-9 13.5a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="flex md:w-[40%] w-[100%] flex flex-col h-[360px] p-6 my-2 text-center text-gray-300 bg-white rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
                        <div className="flex justify-between border-b border-blue-200 border-opacity-20 md:mb-8 mb-0 ">
                            <div className="text-xl tracking-tight font-medium text-black dark:text-white">
                                Summary & Goals
                            </div>
                        </div>

                        <div className="flex justify-center h-[290px] gap-10">
                            <div className="rotate-[-90deg] flex flex-col justify-center items-center">
                                <span className="h-[20px] mb-4 text-black text-sm md:text-base">Achieved Goal : {totalUserAcheivedGoal.length}</span>
                                <span className={`${(totalUserAcheivedGoal.length === 0) ? 'md:w-[72px] w-[60px]' : `w-[${(((totalUserAcheivedGoal.length / userDetails?.userCount) * 100) * 200) / 100}px]`} h-[130px] ${(totalUserAcheivedGoal.length === 0) ? 'bg-gray-400 bg-opacity-20' : 'bg-green-100'}`}></span>
                            </div>
                            <div className="rotate-[-90deg] flex flex-col justify-center items-start">
                                <span className="h-[20px] mb-4 text-black text-sm md:text-base">Total User : {userDetails?.userCount}</span>
                                <span className={`md:w-[72px] w-[60px] h-[130px] bg-[#0694F3]`}></span>
                            </div>
                           
                        </div>
                        {/* One download per reporting category: the recognition
                            list and the follow-up list are used separately. Laid
                            out on a single row so the fixed-height card does not
                            overflow. */}
                        <div className="flex flex-wrap justify-end items-center gap-x-6 gap-y-1 pt-4">
                            <div
                                onClick={() => downloadUserReport(CATEGORY_ACHIEVED)}
                                title="Download the Goal Achievers report"
                                className={`flex items-center font-medium cursor-pointer text-sm ${achieverCount ? 'text-[#0694F3]' : 'text-gray-400'}`}
                            >
                                Goal Achievers ({achieverCount})
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 ml-1.5">
                                    <path fillRule="evenodd" d="M12 2.25a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3a.75.75 0 01.75-.75zm-9 13.5a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div
                                onClick={() => downloadUserReport(CATEGORY_SHORTFALL)}
                                title="Download the Qualified Activity - Goal Not Reached report"
                                className={`flex items-center font-medium cursor-pointer text-sm ${shortfallCount ? 'text-[#0694F3]' : 'text-gray-400'}`}
                            >
                                Goal Not Reached ({shortfallCount})
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 ml-1.5">
                                    <path fillRule="evenodd" d="M12 2.25a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3a.75.75 0 01.75-.75zm-9 13.5a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z" clipRule="evenodd" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
</div>
</>)
}
export default Reportcompany;